import moment from 'moment'
import {useState} from 'react'

export const periods = {
    fromStartOfMonth: () => ({
        from: moment().startOf('month'),
        to: moment().add(1, 'days'),
    }),
    lastWeek: () => ({
        from: moment().subtract(1, 'weeks'),
        to: moment().add(1, 'days'),
    }),
    last30Days: () => ({
        from: moment().subtract(30, 'days'),
        to: moment().add(1, 'days'),
    }),
    last90Days: () => ({
        from: moment().subtract(90, 'days'),
        to: moment().add(1, 'days'),
    }),
}

const usePeriod = () => {
    const [from, setFrom] = useState(null)
    const [to, setTo] = useState(null)
    const [label, setLabel] = useState(null)

    const setPeriod = (period) => {
        const periodObj = periods[period]()
        setFrom(periodObj.from)
        setTo(periodObj.to)
        setLabel(period)
    }

    return {from, to, label, setPeriod}
}

export default usePeriod
